<template>
  <CHeader position="sticky">
    <CContainer fluid>
      <CHeaderToggler class="ps-1">
      </CHeaderToggler>
      <CHeaderBrand class="mx-auto d-lg-none" to="/">

      </CHeaderBrand>
      <CHeaderNav>
        
      </CHeaderNav>
    </CContainer>
  </CHeader>
</template>

<script>
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
export default {
  name: 'AppHeader',
  components: {
    AppHeaderDropdownAccnt,
  },
  setup() {
    return {
    }
  }
}
</script>
